var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-container",style:({
        'background':("linear-gradient(180deg, " + (_vm.colors[_vm.colors.theme].from) + " 0%,  " + (_vm.colors[_vm.colors.theme].to) + " 100%)")
    })},[_c('Header'),_c('slide-content',{attrs:{"routesParams":_vm.routesParams}},[_c('router-view',{attrs:{"reportData":_vm.reportData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }